export enum MatchMailType {
  UnsolicitedRegular = 'unsolicited_regular',
  UnsolicitedHospital = 'unsolicited_hospital',
  Regular = 'regular',
  Hospital = 'hospital',
  CompromiseProcess = 'compromise_process',
}
